module.exports = __webpack_public_path__ + "img/lv3.b07fa68e.png";